export default "__VITE_ASSET__DhAcXWj1__"